import { type PlayerController } from '../player/controller.js';
import { ProductSelector } from './product-selector.js';
import { WindowSelector } from './window-selector.js';

type Props = {
  player: PlayerController;
};

export const Toolbar = ({ player }: Props) => (
  <header class="toolbar">
    <h1 class="toolbar__title">MeteoRadar</h1>
    <div class="toolbar__fields">
      <ProductSelector onSelect={code => player.selectProduct(code)} />
      <WindowSelector onSelect={hours => player.selectWindow(hours)} />
    </div>
  </header>
);
